<!-- <h4 class="title">Overdue Summary</h4> -->
    
    <!-- <div class="row">
        <div class="col-md-5">
            <h5 class="form-lable">Loan Number: <span>1234568908765432</span></h5>
        </div>
        <div class="col-md-5">
            <h5 class="form-lable">Customer Name: <span>Mohammed Imthiyas</span></h5>
        </div>
        <div class="col-md-2 text-right">
            <button type="button" class="btn btn-primary mr-0" (click)="show2()">Add</button>
        </div>
    </div>
    <br> -->
    <div class="doc-table">
        <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
            [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
    
            <ng-template pTemplate="header">
                <tr class="thhead">
                    <th class="th-1">
                        S.No
                    </th>
                    <th>
                        Due Date
                    </th>
                    <th>
                        Principal Amount
                    </th>
    
                    <th>
                      Interest Amount
                  </th>
                <th>
                  LPC Amount
              </th>
              <th>
                BCC Amount
            </th>
            <th>
                Other Amount
            </th>
            <th>
                Total Amount
            </th>
                    <!-- <th style="width: 110px;text-align:center">
                        Action
                    </th> -->
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
                <tr class="tdrow">
                    <td>{{i+1}}</td>
                    <td>20/10/2020</td>
                    <td>1,452.07</td>
                    <td>9.12</td>
                    <td>400.00</td>
                    <td>0.00</td>
                    <td>0.00</td>
                    <td>1,861.19</td>
                    <!-- <td class="act">
                        <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
                        <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
                        <i style="color: #4CAF50;" class="fa fa-info-circle" aria-hidden="true" pTooltip="View"></i>
                    </td> -->
                </tr>
            </ng-template>
         </p-table>  </div>
    
    </div>